import { FakeFlagsAdmin } from "@/components/admin/FakeFlagsAdmin";
import { useEffect, useState } from "react";
import { Loader2, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { UserAvatar } from "@/components/UserBits";
import { SuspectsAdmin } from "@/components/SuspectsAdmin";
import { FakeClustersAdmin } from "@/components/FakeClustersAdmin";

const KINDS = [["quest", "no_quest", "Community-Aufgaben"], ["missions", "no_missions", "Tagesmissionen"], ["points", "no_points", "Punkte-Sammeln"], ["frozen", "points_frozen", "Guthaben (eingefroren)"]];
const anyEx = (u) => u.no_quest || u.no_points || u.no_missions || u.points_frozen;

export function ExclusionsAdmin() {
  const [users, setUsers] = useState(null);
  useEffect(() => {
    api.get("/admin/users").then(({ data }) => setUsers(data.filter(anyEx))).catch((e) => toast.error(formatErr(e)));
  }, []);
  const readmit = async (u, key, field) => {
    try {
      await api.put(`/admin/users/${u.user_id}/exclusions`, { [key]: false });
      setUsers((l) => l.map((x) => (x.user_id === u.user_id ? { ...x, [field]: false } : x)).filter(anyEx));
      toast.success(`${u.name} ist wieder zugelassen`);
    } catch (e) { toast.error(formatErr(e)); }
  };
  if (!users) return <Loader2 className="w-6 h-6 animate-spin text-rose-400 mx-auto" />;
  const addBlocked = (u) => setUsers((l) => { const old = l.find((x) => x.user_id === u.user_id); return [{ ...old, ...u, no_points: true }, ...l.filter((x) => x.user_id !== u.user_id)]; });
  return (
    <div className="space-y-5">
    <FakeFlagsAdmin />
    <SuspectsAdmin onBlocked={addBlocked} />
    <FakeClustersAdmin onBlocked={addBlocked} />
    <div className="rounded-3xl bg-white border border-pink-100 p-5 space-y-4" data-testid="exclusions-admin">
      <div>
        <h2 className="text-lg font-extrabold">Ausgeschlossene Mitglieder</h2>
        <p className="text-sm text-slate-500">Tippe auf eine Aktion, um das Mitglied dort wieder zuzulassen. Neue Ausschlüsse legst du unter „Punktestand“ beim Mitglied fest.</p>
      </div>
      {users.length === 0 ? <p className="text-sm text-slate-400 text-center py-6" data-testid="exclusions-empty">Niemand ist ausgeschlossen 🎉</p> : (
        <ul className="divide-y divide-pink-50" data-testid="exclusions-list">
          {users.map((u) => (
            <li key={u.user_id} className="py-3 flex flex-wrap items-center gap-3" data-testid={`exclusion-row-${u.user_id}`}>
              <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-9 h-9" noStory />
              <div className="flex-1 min-w-0"><p className="font-bold text-sm truncate">{u.name}</p><p className="text-xs text-slate-400 truncate">{u.email}</p></div>
              <div className="flex flex-wrap gap-2 w-full sm:w-auto">
                {KINDS.filter(([, f]) => u[f]).map(([key, field, label]) => (
                  <button key={key} onClick={() => readmit(u, key, field)} data-testid={`readmit-${key}-${u.user_id}`}
                    className="h-9 px-3 rounded-full border-2 border-rose-200 text-rose-600 text-xs font-bold inline-flex items-center gap-1.5 hover:bg-rose-50 active:scale-95 transition-transform">
                    <UserCheck className="w-3.5 h-3.5" /> {label} wieder zulassen
                  </button>
                ))}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
    </div>
  );
}
